import apiReq from '../commontools/api.js'
export function GetCheckModuleValid(){
	var url='/CheckModule/GetCheckModuleValid';
	return apiReq.get(url);
}
export function GetCheckModuleAll(){
	var url='/CheckModule/GetCheckModuleAll';
	return apiReq.get(url);
}
export function AddCheckModule(info){
	var url='/CheckModule/AddCheckModule';
	var p={
		data:info
	}
	return apiReq.post(url,p);
}
export function EditCheckModule(info){
	var url='/CheckModule/EditCheckModule';
	var p={
		data:info
	}
	return apiReq.post(url,p);
}
export default{
	GetCheckModuleValid,
	GetCheckModuleAll,
	AddCheckModule,
	EditCheckModule
}